import { openNewTab } from '../../helpers';

export default function customHeaderButtons() {
  const widgetName = 'customHeaderButtons';
  const widgetOpts = customHeaderButtonsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 2,
    maxItemsVisible: 2,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomHeaderButtons(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomHeaderButtons(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL, Description } = widgetData[x];
      const $item = $(this);

      const customClass = getCustomClass(Title);

      if (URL) {
        $item.replaceWith(`
        <a href="${URL}" class='header-nav ${customClass}' ${openNewTab(URL)} aria-label="${Description}">
          <span>${Description}</span>
        </a>`);
      } else {
        $item.remove();
      }
    });
  }
}

function getCustomClass(Title) {
  if (Title == '{FAIR LINK}') {
    return 'fair-icon';
  }

  if (Title === '{RESERVATIONS LINK}') {
    return 'reserv-icon';
  }

  return '';
}
